export class Camera {

    id: number;
    name: string;

    constructor(camera?: any) {
        if (camera != null) {
            this.id = camera.id;
            this.name = camera.name;
        }
    }

}